// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__f75cbd487e5d8a56c8d3","cls2":"Comments-cls2__eab65e9a31e23c2a28f4 Comments-cls1__f75cbd487e5d8a56c8d3"};